<div class="container">
  <div
    *ngFor="let zone of vm.zones"
    [ngStyle]="zone.styleObject"
    class="zone"
    (dragover)="$event.preventDefault()"
    (drop)="vm.onDrop($event, zone)"
    [ngClass]="{ 'empty-zone': zone.zoneType === 3 }"
    title="{{ zone.mediaName }}"
  >
    <span *ngIf="zone.index === 0" title="{{ zone.mediaName }}">BASE ZONE</span>
    <span *ngIf="zone.index > 0" title="{{ zone.mediaName }}"
      >ZONE {{ zone.index }}</span
    >
    <img
      *ngIf="zone.zoneType !== 3"
      src="{{ zone.mediaThumbnailUrl }}"
      alt="Problem loading the thumbnail"
    />

    <h2 *ngIf="zone.zoneType === 3">Drag & Drop here</h2>
  </div>
</div>
